import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import { Heading, Row, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';
import { CustomerModule } from '@/modules/common/store/CustomerModule';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { PortfolioAboutData } from '@/modules/wealth/services/portfolio';

interface Props {
  aboutData: PortfolioAboutData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutLinks',
  props: {
    aboutData: null
  },
  setup(__props: any) {

const props = __props as {
  aboutData: PortfolioAboutData;
}



const route = useRoute();

const portfolioId = computed(() => {
  return route.params.portfolioId;
});

const faqRoute = computed(() => {
  if (props.aboutData?.faq?.id) {
    return {
      name: 'help-center-section',
      params: {
        id: props.aboutData.faq.id
      }
    };
  }
  return { name: 'help-center' };
});

const isCustomerPJ = computed(() => {
  return !!CustomerModule?.getCustomer?.professionalProfile;
});

const showIncomeTax = computed(() => {
  return !isCustomerPJ.value && !CustomerModule?.isImpersonated;
});

const showStatementsAndNote = computed(() => {
  return FeatureFlagsModule.isEnabled(
    FeatureFlags.ENABLE_STATEMENTS_AND_NOTES_ON_INDEX_PORTFOLIO
  );
});

return { __sfc: true,props, route, portfolioId, faqRoute, isCustomerPJ, showIncomeTax, showStatementsAndNote, Heading, Row, InitialAvatarIcon }
}

})